import { Tooltip } from 'antd';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/common/Button';
import CountdownTimer from 'src/components/common/CountdownTimer';
import { SvgIcon } from 'src/components/common/SvgIcon';
import { setBodyOverflow } from 'src/helpers/utils';
import { MediaManager } from 'src/manager/MediaManager';
import SafeTermsAndConditionsModal from '../SafeTermsAndConditionsModal';
import './styles.scss';

const SafePromoBanner: FC = () => {
  const { t }: Translation = useTranslation();

  // States
  const [openSafeTermsAndConditionsModal, setOpenSafeTermsAndConditionsModal] = useState<boolean>(false);

  // Actions
  const handleOpenSafeTermsAndConditionsModal = (): void => {
    setBodyOverflow('unset');
    setOpenSafeTermsAndConditionsModal(true);
  };

  const handleCloseSafeTermsAndConditionsModal = (): void => {
    setBodyOverflow('set');
    setOpenSafeTermsAndConditionsModal(false);
  };

  return (
    <>
      <div className="safe_promo_banner">
        <img
          src={MediaManager.getSrcFromMediaAssets('safe_promo_banner.png', '/safePromo/')}
          alt="banner"
          className="safe_promo_banner_img"
        />
        <div className="safe_promo_banner_info">
          <div className="safe_promo_banner_countdown_wrapper">
            <h3 className="safe_promo_banner_countdown_title">{t('safe_promo.bannerCountdownTitle')}</h3>
            <div className="safe_promo_banner_countdown_container">
              <div className="safe_promo_banner_countdown_body">
                <Tooltip placement="top" title={t('safe_promo.bannerCountdownTooltip')}>
                  <div className="safe_promo_banner_countdown_info_icon">
                    <SvgIcon src="/images/icons/svg/circle-exclamation-solid.svg" size="md" color="primaryText" />
                  </div>
                </Tooltip>
                <CountdownTimer
                  size="xxxl"
                  view="names"
                  showDays={false}
                  targetDate={'2025-05-31T11:22:53.000Z'}
                  longNames
                  classname="safe_promo_banner_countdown"
                />
              </div>
            </div>
          </div>
          <div className="safe_promo_banner_terms_wrapper">
            <h3 className="safe_promo_banner_title">{t('safe')}</h3>
            <Button className="safe_promo_banner_terms_link" onClick={handleOpenSafeTermsAndConditionsModal}>
              {t('terms_and_conditions')}
            </Button>
          </div>
        </div>
      </div>
      <SafeTermsAndConditionsModal
        isOpen={openSafeTermsAndConditionsModal}
        onClose={handleCloseSafeTermsAndConditionsModal}
      />
    </>
  );
};

export default SafePromoBanner;
